var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Signout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-sign_out",
    "data-name": "icon-24-sign out",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M7.5,18H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H7.5A.5.5,0,0,1,8,.5v1a.5.5,0,0,1-.5.5H2V16H7.5a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,7.5,18Zm4.785-3a.5.5,0,0,1-.355-.148l-.71-.7a.5.5,0,0,1,0-.71L14.67,10H4.5A.5.5,0,0,1,4,9.5v-1A.5.5,0,0,1,4.5,8H14.67L11.22,4.56a.489.489,0,0,1,0-.7l.71-.71a.5.5,0,0,1,.709,0L17.78,8.28a.768.768,0,0,1,.22.53v.38a.755.755,0,0,1-.22.53L12.64,14.85A.5.5,0,0,1,12.285,15Z",
    transform: "translate(3 3)",
    fill: "#02466a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Signout);
export default __webpack_public_path__ + "static/media/icon-24-sign out.1abf07cc7c643da7fb1ba594400baa21.svg";
export { ForwardRef as ReactComponent };